const SectionGiftCard = Class(
	/**
	 * @lends {SectionGiftCard#}
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'gift-card',

		route: function() {
			let part = this.url.shift();
			switch (part) {
				case 'event':
					let event = this.url.shift();
					if (!event) {
						Section.navigate(D.url('/gift-card/events'));
					}
					let lastPart = this.url.shift();
					if (lastPart === 'processing') {
						return new SectionGiftCard.Processing(event);
					}
					if (D.ID) {
						return new SectionGiftCard.Buy(event);
					}
					Section.navigate(D.url('/sign-in?redirect=' + encodeURIComponent('/gift-card/event/' + event)));
					break;
				case 'events':
					return new SectionGiftCard.SelectGame();
			}
			if (this.url.get.is('pmt-success')) {
				return new SectionGiftCard.Success();
			}
		},

		draw: function() {
			let prefix = D.SITE_B2B ? 'b2b.' : '';
			this.node = mkE({
				tag: 'div',
				id: 'SectionGiftCard',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container',
						els: [
							{
								tag: 'div',
								className: 'overline',
								text: t(prefix + 'gift-card.hero.overline.title')
							},
							{
								tag: 'h1',
								text: t(prefix + 'gift-card.hero.overline.h2')
							},
							{
								tag: 'p',
								text: t(prefix + 'gift-card.hero.overline.p')
							},
							{
								tag: 'div',
								className: 'hero__btn',
								els: [
									{
										tag: 'a',
										className: 'button button-pink',
										text: t(prefix + 'gift-card.hero.button.text'),
										href: D.url('/gift-card/events')
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container gift_card__rules mb-5',
						els: [
							{
								tag: 'div',
								className: 'content',
								els: (() => {
									let els = [
										{
											tag: 'h2',
											text: D.Lang.get('gift-card.rules.title-full')
										}
									];
									const rulesCount = Number(D.Lang.get('gift-card.rules.children.count') || 0);
									for (let i = 0; i < rulesCount; i++) {
										let rules = [];
										let children = Number(D.Lang.get('gift-card.rules.children.' + i + '.count') || 0);
										for (let j = 0; j < children; j++) {
											rules.push({
												tag: 'li',
												els: [
													{
														tag: 'p',
														text: D.Lang.get('gift-card.rules.children.' + i + '.children.' + j)
													}
												]
											});
										}
										els.push({
											tag: 'ul',
											els: rules
										});
									}
									return els;
								})()
							}
						]
					},
					new T.FAQ({
						title: D.Lang.get('gift-card.faq.title'),
						prefix: 'gift-card.faq',
						className: 'container mb-4',
					})
				]
			}).append(this.layout.ct());
			this.ready();
		},

		onShow() {
			this.fadeOnShow();
		},

		onScroll() {
			this.fadeOnScroll();
		}
	},
	Section
);

SectionGiftCard.SelectGame = Class(
	/**
	 * @lends {SectionGiftCard.SelectGame#}
	 */
	{
		__NAME: 'SectionGiftCard.SelectGame',

		bodyClass: 'small-nav grey hide-tablet-footer full-container',
		menuItem: 'gift-card',

		_selectedType: null,
		_selectedEvent: null,

		_events: {},
		_typeOptions: {},
		_eventOptions: {},

		draw() {
			this._mGetEvents = new DR.events.GetEventsList();
			this._mGetEvents.type = DR.events.GetEventsList.TYPE_GIFTCARDS;
			this._mGetEvents.select = [
				new DR.events.select.Event().id().
					title().
					image().
					region().
					startTime().
					endTime().
					seoTitle().
					hasImage().
					settings().
					ticket().
					minPlayers().
					maxPlayers().
					languages().
					description(),
				new DR.roadgames.select.Image().large()
			];
			this._mGetEvents.onLoad = this._mGetEventsRe;
			this.meta.setSection('gift-card/events');
			this.apiCall.addMethod(this._mGetEvents);
			this.apiCall.call();
		},

		_mGetEventsRe() {
			this._mGetEvents.re.events = this._mGetEvents.re.events.map(e => e.event);
			this._events = {
				foot: this._mGetEvents.re.events.filter(event => {
					if (!event.ticket.affiliatePrice) {
						return false;
					}
					return event.settings.transportType === 'foot';
				}),
				car: this._mGetEvents.re.events.filter(event => {
					if (!event.ticket.affiliatePrice) {
						return false;
					}
					return event.settings.transportType === 'car';
				}),
				bicycle: this._mGetEvents.re.events.filter(event => {
					if (!event.ticket.affiliatePrice) {
						return false;
					}
					return event.settings.transportType === 'bicycle';
				})
			};
			this.node = mkE({
				tag: 'div',
				id: 'SectionGiftCardSelectGame',
				className: 'container',
				els: [
					{
						tag: 'div',
						className: 'gift-card-events-top',
						els: [
							{
								tag: 'h1',
								className: 'h2',
								text: D.Lang.get('gift-card.select-event')
							},
							this._eventTypes = mkE({
								tag: 'div',
								className: 'gift-card-event-types'
							})
						]
					},
					this._eventList = mkE({
						tag: 'div',
						className: 'gift-card-event-list'
					}),
					{
						tag: 'div',
						className: 'gift-card-event-button',
						els: [
							this._button = mkE({
								tag: 'button',
								className: 'button button-pink button-disabled',
								text: D.Lang.get('gift-card.continue'),
								onclick: this._continue,
								attr: {
									disabled: true
								}
							})
						]
					}
				]
			}).append(this.layout.ct());
			['foot', 'car', 'bicycle'].forEach(type => {
				if (!this._events[type].length) {
					return;
				}
				this._typeOptions[type] = mkE({
					tag: 'div',
					className: `gift-card-event-type gift-card-event-type-${type}`,
					els: [
						{
							tag: 'div',
							className: 'type-image'
						},
						D.Lang.get(`gift-card.event-type.${type}`)
					],
					onclick: D.closure(this, this._selectType, type)
				}).append(this._eventTypes);
			});
			if (this._events['foot'].length) {
				this._selectType('foot');
			} else if (this._events['car'].length) {
				this._selectType('car');
			} else if (this._events['bicycle'].length) {
				this._selectType('bicycle');
			}
		},

		_selectType(selectedType) {
			Object.keys(this._typeOptions).forEach(type => {
				if (type === selectedType) {
					addClassName(this._typeOptions[type], 'active');
				} else {
					removeClassName(this._typeOptions[type], 'active');
				}
			});
			this._selectedType = selectedType;
			this._drawEvents();
		},

		_drawEvents() {
			this._selectEvent(null);
			clearNode(this._eventList);
			mkE({
				tag: 'div',
				className: 'gift-card-event-list-header',
				els: [
					{
						tag: 'div',
						className: 'left',
						text: D.Lang.get('gift-card.list.header.event')
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							{
								tag: 'div',
								text: D.Lang.get('gift-card.list.header.language')
							},
							{
								tag: 'div',
								text: D.Lang.get('gift-card.list.header.length')
							},
							{
								tag: 'div',
								text: D.Lang.get('gift-card.list.header.team')
							},
							{
								tag: 'div',
								text: D.Lang.get('gift-card.list.header.price')
							}
						]
					}
				]
			}).append(this._eventList);

			const anyPrice = '14-28';
			this._eventOptions[-1] = this._drawEvent(
				'/assets/images/gift-card/unknown-game.svg?v=2',
				D.Lang.get('gift-card.event.unknown.title'),
				D.Lang.get('gift-card.event.unknown.caption_alt').replace('%PRICE%', anyPrice),
				'2-4h',
				'1-5',
				anyPrice,
				-1
			).append(this._eventList);

			this._events[this._selectedType].forEach(event => {
				let players;
				let hours = Math.ceil((event.endTime - event.startTime) / 3600);
				if (event.settings.gameType === 'anytime') {
					hours = Math.ceil(event.settings.gameTime / 60);
				}
				hours = hours + 'h';
				let price = event.ticket.affiliatePrice / 100;
				if (event.minPlayers === event.maxPlayers) {
					players = event.maxPlayers;
				} else {
					players = event.minPlayers + '-' + event.maxPlayers;
					if (event.settings.ticketPerPerson) {
						price = (event.minPlayers * event.ticket.affiliatePrice / 100) + '-' + (event.maxPlayers * event.ticket.affiliatePrice / 100);
					}
				}
				let startDate = new D.Date(event.startTime);
				let now = new D.Date(new Date().getTime / 1000);
				let sameYear = startDate.format('Y') === now.format('Y');
				let year = startDate.format('Y');
				let day = startDate.format('j');
				let month = startDate.format('%F');
				let time = startDate.format('H:i');
				let date = sameYear ? D.Lang.get('gift-card.event.date') : D.Lang.get('gift-card.event.dateNext');
				date = date.replace('%YEAR%', year).replace('%DAY%', day).replace('%MONTH%', month).replace('%TIME%', time);
				let caption = D.Lang.get('gift-card.event.start') + ': ' + date;
				if (event.settings.gameType === 'anytime') {
					caption = D.Lang.get('gift-card.event.start-any-time');
				}
				let languages = event.languages.map(l => l.toLocaleUpperCase()).join(', ');

				this._eventOptions[event.id] = this._drawEvent(event.image.large, event.title, caption, hours, players, price, event.id, languages,
					event.description).append(this._eventList);
			});
		},

		_drawEvent(image, title, caption, hours, players, price, id, languages, description) {
			return mkE({
				tag: 'div',
				className: 'gift-card-list-event',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							{
								tag: 'div',
								className: 'radio'
							},
							{
								tag: 'div',
								className: 'image',
								style: {
									backgroundImage: `url('${image}')`
								}
							},
							{
								tag: 'div',
								className: 'info',
								els: [
									{
										tag: 'h4',
										text: title
									},
									{
										tag: 'div',
										className: 'caption',
										text: caption
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'right',
						els: [
							{
								tag: 'div',
								className: (id === -1 ? 'hidden-mobile' : ''),
								els: [
									{
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('gift-card.list.header.language')
									},
									{
										tag: 'p',
										text: languages
									}
								]
							},
							{
								tag: 'div',
								els: [
									{
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('gift-card.list.header.length')
									},
									{
										tag: 'p',
										text: hours
									}
								]
							},
							{
								tag: 'div',
								els: [
									{
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('gift-card.list.header.team')
									},
									{
										tag: 'p',
										text: players
									}
								]
							},
							{
								tag: 'div',
								els: [
									{
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('gift-card.list.header.price')
									},
									{
										tag: 'h4',
										text: price + ' €'
									}
								]
							}
						]
					},
					description ? {
						tag: 'div',
						className: 'event-description',
						els: [
							{
								tag: 'p',
								text: description
							},
							{
								tag: 'div',
								className: 'text-toggle-container',
								els: [
									{
										tag: 'a',
										text: D.Lang.get('gift-cards.list.read-more'),
										prop: {
											onclick: (e) => {
												let link = e.target;
												let parent = link.closest('.event-description');
												if (existsClassName(parent, 'open')) {
													removeClassName(parent, 'open');
													setNodeText(link, D.Lang.get('gift-cards.list.read-more'));
												} else {
													addClassName(parent, 'open');
													setNodeText(link, D.Lang.get('gift-cards.list.read-less'));
												}
												e.preventDefault();
												e.stopPropagation();
												return false;
											}
										}
									}
								]
							}
						]
					} : null
				],
				onclick: D.closure(this, this._selectEvent, id)
			});
		},

		_selectEvent(event) {
			if (this._eventOptions[this._selectedEvent]) {
				removeClassName(this._eventOptions[this._selectedEvent], 'active');
			}
			this._selectedEvent = event;
			if (this._eventOptions[this._selectedEvent]) {
				addClassName(this._eventOptions[this._selectedEvent], 'active');
			}
			this._checkButton();
		},

		_checkButton() {
			if (!this._selectedEvent) {
				addClassName(this._button, 'button-disabled');
				this._button.disabled = true;
				return;
			}
			removeClassName(this._button, 'button-disabled');
			this._button.disabled = false;
		},

		_continue() {
			if (this._selectedEvent === -1) {
				Section.navigate(D.url('/gift-card/event/unknown'));
				return;
			}
			let event = this._events[this._selectedType].find(event => event.id === this._selectedEvent);
			Section.navigate(D.url(`/gift-card/event/${event.seoTitle}`));
		}
	},
	Section
);

SectionGiftCard.Buy = Class(
	/**
	 * @lends {SectionGiftCard.Buy#}
	 */
	{
		bodyClass: 'small-nav grey hide-tablet-footer full-container',
		name: 'giftcard-buy',
		menuItem: 'gift-card',

		TYPE_PRIVATE: 'private',
		TYPE_COMPANY: 'company',

		PAYMENT_METHOD: 'every-pay',

		_isEveryPayOK: true,

		__construct(event) {
			// if (![8, 15, 2384, 856, 63373].includes(D.ID)) {
			// 	this.PAYMENT_METHOD = 'braintree';
			// }
			this.eventUrl = event;
			this._companyFields = {};
			this.countries = Object.entries(D.Lang.get('countries')).
					map(([key, value]) => ({
						value: key,
						caption: value,
					}));
			this._mCheckVAT = new DR.services.CheckVAT();
			this._mCheckVAT.onLoad = this._mCheckVATRe;
			this._mCheckVAT.onError = this._mCheckVATErr;

			if (this.PAYMENT_METHOD === DR.services.PurchaseTicket.PAYMENTMETHOD_EVERYPAY) {
				this._everyPay = new T.EveryPay({
					apiCall: this.apiCall,
					onInit: this._onEveryPayInit,
					onChange: this._onEveryPayChange,
				});
			}
		},

		draw: function() {
			new RPC('/api/web_rpc.php').send('getGiftCardEventData', {
				eventUrl: this.eventUrl
			}, this._onRPCData);
		},

		_onRPCData(data) {
			this.apiCall.onLoad = () => {
				this._onData(data);
			};
			this.apiCall.call();
		},

		_onData: function(data) {
			this.data = data;
			this.user = data.user;
			this._hasVAT = true;

			if (data.meta) {
				this.meta
					.setTitle(data.meta.title)
					.setDescription(data.meta.description)
					.setOgImage(data.meta.ogImage)
			} else {
				this.meta.setSection('gift-card/events');
			}

			this.node = mkE({
				tag: 'div',
				id: 'SectionGiftCardBuy'
			}).append(this.layout.ct());

			this._drawHeader();

			this._drawContent();

			mkE({
				tag: 'div',
				className: 'container purchase-disclaimer centered',
				els: [
					{
						tag: 'div',
						className: 'disclaimer',
						els: [
							D.Lang.get('profile.team.purchase.receiver'),
							{
								tag: 'br'
							},
							D.Lang.get('profile.team.purchase.address')
						]
					}
				]
			}).append(this.node);

			this._gtagPricing.send('add_to_cart');

			if (this._everyPay) {
				D.insertAfter(this._everyPay.node, this._discountSuggestion);
				this._everyPay.draw();
			}

			this.ready();
		},

		_drawHeader() {
			let header = mkE({
				tag: 'div',
				className: 'header container'
			}).append(this.node);
			let title = mkE({
				tag: 'h4'
			}).append(header);
			if (this.data.custom) {
				mkE.appendTypeElement(title, D.Lang.get('team-building'))
			}
			else if (this.data.id === 0) {
				mkE.appendTypeElement(title, D.Lang.get('gift-card'));
			} else {
				mkE.appendTypeElement(title, [
					{
						tag: 'span',
						className: 'prefix',
						text: D.Lang.get('gift-card') + ' - '
					},
					this.data.title
				]);
			}
			let caption = D.Lang.get('gift-card.event.start-any-time');
			if (this.data.id && this.data.type !== 'anytime') {
				caption = D.Date.formatDateRange(this.data.startTime, this.data.endTime, 'j. %F, H:i', 'H:i', ' - ');
			}
			mkE({
				tag: 'div',
				className: 'caption',
				text: caption
			}).append(header);
		},

		_drawContent() {
			this._selectedTab = this.TYPE_PRIVATE;
			this._tabHeaders = {};
			this._tabs = {};
			let content = mkE({
				tag: 'div',
				className: 'content container'
			}).append(this.node);
			if (new Get().is('payment-failed')) {
				T.error(D.Lang.get('profile.team.purchase.errors.payment_failed')).append(content);
			}
			mkE({
				tag: 'h2',
				text: this.data.custom ? D.Lang.get('team-building') : D.Lang.get('gift-card')
			}).append(content);

			let description = D.Lang.get('gift-card.event.description.default_options');
			if (this.data.type === 'anytime') {
				description = D.Lang.get('gift-card.event.description.anytime');
			} else if (this.data.type === 'race') {
				description = D.Lang.get('gift-card.event.description.race');
			}
			description = description.replace(/%TITLE%/g, this.data.title || '').
				replace(/%MIN_PLAYERS%/g, this.data.minPlayers || 0).
				replace(/%MAX_PLAYERS%/g, this.data.maxPlayers || 0).
				replace(/%PRICE%/g, (this.data.price / 100).toFixed(2));

			if(this.data.custom) {
				description = '';
			}

			mkE({
				tag: 'p',
				className: 'description',
				innerHTML: description
			}).append(content);

			this._errorHolder = mkE({
				tag: 'div'
			}).append(content);

			let selector = '';
			if (this.data.priceOptions) {
				selector = this._getPriceOptionsSelector();
			} else if (this.data.ticketPerPerson) {
				selector = this._getPersonSelector();
			} else {
				selector = this._getTeamCountToggle();
			}

			this._purchaseForm = mkE({
				tag: 'div',
				className: 'team-create-purchase-form',
				els: [
					{
						tag: 'div',
						className: 'purchase-tabs',
						els: [
							{
								tag: 'div',
								className: 'purchase-tabs-header',
								els: [
									this._tabHeaders[this.TYPE_COMPANY] = new T.Form.CheckBox({
										caption: mkE({
											tag: 'span',
											className: 'purchase-type-checkbox',
											text: D.Lang.get('profile.team.purchase.tabs.company')
										}),
										checked: false,
										onChange: D.closure(this, function() {
											if (this._tabHeaders[this.TYPE_COMPANY].value()) {
												this._selectedTab = this.TYPE_COMPANY;
												addClassName(this._tabs[this.TYPE_COMPANY], 'active');
												removeClassName(this._tabs[this.TYPE_PRIVATE], 'active');
											} else {
												this._selectedTab = this.TYPE_PRIVATE;
												addClassName(this._tabs[this.TYPE_PRIVATE], 'active');
												removeClassName(this._tabs[this.TYPE_COMPANY], 'active');
											}
											this._checkVAT();
										})
									})
								]
							},
							{
								tag: 'div',
								className: 'purchase-tabs-content',
								els: [
									this._tabs[this.TYPE_PRIVATE] = mkE({
										tag: 'div',
										className: 'purchase-tab purchase-tab-private' + (this._selectedTab === this.TYPE_PRIVATE ? ' active' : ''),
										els: [
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: []
											}
										]
									}),
									this._tabs[this.TYPE_COMPANY] = mkE({
										tag: 'div',
										className: 'purchase-tab purchase-tab-company' + (this._selectedTab === this.TYPE_COMPANY ? ' active' : ''),
										els: [
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													{
														tag: 'div',
														className: 'left',
														els: [
															this._companyFields['name'] = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.name'),
																border: true,
																value: ''
															})
														]
													},
													{
														tag: 'div',
														className: 'right',
														els: [
															this._companyFields['phone'] = new T.Form.Phone({
																caption: D.Lang.get('profile.team.purchase.company.phone'),
																border: true,
																code: 371,
																value: ''
															})
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													{
														tag: 'div',
														className: 'left',
														els: [
															this._companyFields['reg'] = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.reg'),
																border: true,
																value: ''
															})
														]
													},
													{
														tag: 'div',
														className: 'right',
														els: [
															this._companyFields['vat'] = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.vat'),
																border: true,
																value: '',
																onChange: this._checkVAT
															})
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'form-row form-row-2',
												els: [
													{
														tag: 'div',
														className: 'left',
														els: [
															this._companyFields['country'] = new T.Form.Select({
																caption: D.Lang.get('profile.team.purchase.company.country'),
																border: true,
																options: this.countries,
																value: 'LV',
																onChange: this._onChangeCountry
															})
														]
													},
													{
														tag: 'div',
														className: 'right',
														els: [
															this._companyFields['city'] = new T.Form.Input({
																caption: D.Lang.get('profile.team.purchase.company.city'),
																border: true,
																value: ''
															})
														]
													}
												]
											},
											{
												tag: 'div',
												className: 'form-row',
												els: [
													this._companyFields['address'] = new T.Form.Input({
														caption: D.Lang.get('profile.team.purchase.company.address'),
														border: true,
														value: ''
													})
												]
											}
										]
									})
								]
							}
						]
					},
					selector,
					this._teamCountContainer = mkE({
						tag: 'div',
						className: 'team-count-container',
						els: [
							{
								tag: 'div',
								className: 'label',
								els: [
									{
										tag: 'div',
										className: 'caption',
										text: D.Lang.get('profile.team.purchase.teamCount')
									}
								]
							},
							this._teamCount = new T.Form.Count({
								min: 1,
								max: 100,
								value: 1,
								onChange: this._onTeamCountChange
							})
						]
					}),
					{
						tag: 'div',
						className: 'gift-card-price',
						els: [
							{
								tag: 'div',
								className: 'label',
								text: D.Lang.get('profile.team.purchase.totalAmount')
							},
							this._priceText = mkE({
								tag: 'h3'
							})
						]
					},
					this._discountSuggestion = mkE({
						tag: 'div',
						className: 'discount-suggestion'
					}),
					{
						tag: 'div',
						className: 'purchase-disclaimer-mobile',
						els: [
							{
								tag: 'div',
								className: 'disclaimer',
								els: [
									D.Lang.get('profile.team.purchase.receiver'),
									{
										tag: 'br'
									},
									D.Lang.get('profile.team.purchase.address')
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'gift-card-button',
						els: [
							this._bottomContentNode = mkE({
								tag: 'div',
								className: 'gift-card-bottom-content'
							}),
							this._buyButton = mkE({
								tag: 'button',
								className: 'button button-pink',
								text: D.Lang.get('gift-card.purchase'),
								onclick: this._checkPurchase
							})
						]
					}
				]
			}).append(content);

			if (D.SITE_B2B) {
				this._tabHeaders[this.TYPE_COMPANY].value(true);
				this._tabHeaders[this.TYPE_COMPANY].par.onChange();
			}

			this._updatePrice();
		},

		_onChangeCountry() {
			this._checkVAT();
		},

		_getPersonSelector() {
			let node = mkE({
				tag: 'div',
				className: 'team-ticket-counts'
			});
			mkE({
				tag: 'div',
				className: 'team-users-count',
				els: [
					{
						tag: 'div',
						className: 'label',
						els: [
							{
								tag: 'div',
								className: 'caption',
								els: [
									D.Lang.get('profile.team.purchase.teamUserCount'),
									{
										tag: 'span',
										text: D.Lang.get('profile.team.purchase.teamUserCount2').
											replace('%MIN_PLAYERS%', this.data.minPlayers).
											replace('%MAX_PLAYERS%', this.data.maxPlayers)
									}
								]
							},
							{
								tag: 'div',
								className: 'team-count-toggle',
								els: [
									{
										tag: 'a',
										onclick: this._toggleTeamCount,
										text: D.Lang.get('profile.team.purchase.teamCountToggle')
									}
								]
							}
						]
					},
					this._teamUsersCount = new T.Form.Count({
						min: this.data.minPlayers,
						max: this.data.maxPlayers,
						value: this.data.minPlayers,
						onChange: this._onTeamUsersChange
					})
				]
			}).append(node);

			return node;
		},

		_onTeamUsersChange() {
			this._updatePrice();
		},

		_getTeamCountToggle() {
			return mkE({
				tag: 'div',
				className: 'team-count-toggle-single',
				els: [
					{
						tag: 'a',
						onclick: this._toggleTeamCount,
						text: D.Lang.get('profile.team.purchase.teamCountToggle')
					}
				]
			});
		},

		_toggleTeamCount() {
			if (this._teamCountVisible) {
				this._teamCountVisible = false;
				this._tempTeamCount = this._teamCount.value();
				this._teamCount.value(1);
				removeClassName(this._teamCountContainer, 'active');
			} else {
				this._teamCountVisible = true;
				if (this._tempTeamCount) {
					this._teamCount.value(this._tempTeamCount);
					delete this._tempTeamCount;
				}
				addClassName(this._teamCountContainer, 'active');
			}
			this._onTeamCountChange();
		},

		_onTeamCountChange() {
			this._updatePrice();
		},

		/** @type {int[]|null} **/
		_priceOptionsInputs: null,

		_getPriceOptionsSelector() {
			let els = [];
			this._priceOptionsInputs = [];
			for (let i = 0; i < this.data.priceOptions.length; i++) {
				const priceOption = this.data.priceOptions[i];
				let input;
				els.push({
					tag: 'div',
					els: [
						{
							tag: 'div',
							className: 'label',
							els: [
								{
									tag: 'div',
									className: 'caption',
									text: D.Lang.get(this.data.custom ? 'profile.team.purchase.custom.price_options' : 'profile.team.purchase.price_options').
										replace('%PRICE%', (priceOption.price / 100).toFixed(priceOption.price % 100 ? 2 : 0))
								}
							]
						},
						input = new T.Form.Count({
							min: 0,
							max: 100,
							value: priceOption.default || 0,
							onChange: this._onPriceOptionsCountChange
						})
					]
				});
				this._priceOptionsInputs.push(input);
			}
			return mkE({
				tag: 'div',
				className: 'price-options-container',
				els: els
			});
		},

		_onPriceOptionsCountChange() {
			this._updatePrice();
		},

		_getPriceOptionsData() {
			if (!this.data.priceOptions) {
				return null;
			}
			let data = [];
			for (let i = 0; i < this.data.priceOptions.length; i++) {
				const priceOption = this.data.priceOptions[i];
				const count = this._priceOptionsInputs[i].value();
				if (count > 0) {
					data.push({
						price: priceOption.price,
						count: count
					});
				}
			}
			return data;
		},

		_checkVAT: function() {
			this._buyButton.disabled = true;
			this._mCheckVAT.type = this._tabHeaders[this.TYPE_COMPANY].value() ? 'company' : 'private';
			this._mCheckVAT.country = this._companyFields.country.value();
			this._mCheckVAT.vatNumber = this._companyFields.vat.value() || null;
			this._mCheckVAT.call({eventId: this.data.id});
		},

		_mCheckVATRe: function() {
			this._hasVAT = this._mCheckVAT.re.hasVAT;
			this._updatePrice();
			this._buyButton.disabled = false;
		},

		_mCheckVATErr: function() {
			this._hasVAT = true;
			this._updatePrice();
			this._buyButton.disabled = false;
		},

		_price: 0,

		/** @type {D.gtag.Pricing} */
		_gtagPricing: null,

		_updatePrice() {
			this._price = 0;
			this._gtagPricing = new D.gtag.Pricing({
				vat: this.data.vat,
				custom: {
					is_business: this._selectedTab === this.TYPE_COMPANY,
					has_vat: this._hasVAT,
				}
			});
			let giftCardCount = 0;
			if (this.data.priceOptions) {
				for (let i = 0; i < this.data.priceOptions.length; i++) {
					const priceOption = this.data.priceOptions[i];
					const count = this._priceOptionsInputs[i].value();
          let price = this._hasVAT ? priceOption.price : priceOption.priceNoVAT;
          this._price += price * count;
          giftCardCount += count;
					if (count > 0) {
						this._gtagPricing.addItem({
							item_id: `GC_${this.data.id}_${priceOption.price}`,
							item_name: this.data.id > 0	? `Gift card: ${this.data.title}`	: 'Gift card: Any',
							price: priceOption.priceNoVAT,
							priceVAT: priceOption.price,
							quantity: count,
						});
					}
				}
			} else {
				let price = this._hasVAT ? this.data.price : this.data.priceNoVAT;
				let count = 1;
				if (this.data.ticketPerPerson && this._teamUsersCount) {
					count = this._teamUsersCount.value();
				}
				count *= this._teamCount.value();
				price *= count;
				this._price = price;
				giftCardCount = this._teamCount.value();
        if (count > 0) {
          this._gtagPricing.addItem({
	          item_id: `GC_${this.data.id}`,
	          item_name: this.data.id > 0 ? `Gift card: ${this.data.title}` : 'Gift card: Any',
						item_url: D.url('/event/' + this.data.seoTitle, null, true),
						item_image_url: this.data.image,
	          price: this.data.priceNoVAT,
						priceVAT: this.data.price,
	          quantity: count,
          });
        }
			}

			const bulkDiscounts = [
				{count: 50, discount: 20},
				{count: 20, discount: 15},
				{count: 5, discount: 10},
				{count: 3, discount: 5},
				{count: 0, discount: 0}
			];
			let discount = 0, offerBulkDiscount = null;
			for (let i = 0; i < bulkDiscounts.length; i++) {
				const bulkDiscount = bulkDiscounts[i];
				if (giftCardCount >= bulkDiscount.count) {
					discount = bulkDiscount.discount;
					let nextDiscount = bulkDiscounts[i - 1];
					if (nextDiscount) {
						offerBulkDiscount = nextDiscount;
					}
					break;
				}
			}

			if (this.data.custom) {
				offerBulkDiscount = false;
			}

			clearNode(this._priceText);
			if (discount > 0) {
				this._gtagPricing.applyDiscount(`B${discount}`, discount, true);
				discount /= 100;
				let priceWithoutDiscount = this._price;
				let discountValue = this._price * discount;
				this._price -= discountValue;
				let els = [
					{
						tag: 'span',
						className: 'grey-strike-text',
						text: '€' + (priceWithoutDiscount / 100).toFixed(2)
					},
					'€' + (this._price / 100).toFixed(2)
				];
				mkE.appendTypeElement(this._priceText, els);
			} else {
				setNodeText(this._priceText, '€' + (this._price / 100).toFixed(2));
			}

			clearNode(this._discountSuggestion);
			if (offerBulkDiscount) {
				setNodeText(
					this._discountSuggestion,
					D.Lang.get('gift-card.purchase.bulk-offer').
						replace('%COUNT%', offerBulkDiscount.count - giftCardCount).
						replace('%DISCOUNT%', offerBulkDiscount.discount)
				);
			}
		},

		_checkPurchase: function() {
			if (this._everyPay && !this._isEveryPayOK) {
				return;
			}
			if (this._isCheckingPurchase) {
				return;
			}
			if (this._errorNodeCheck) {
				this._errorNodeCheck.remove();
			}
			let formType = this._tabHeaders[this.TYPE_COMPANY].value() ? 'company' : 'private';
			let data = {
				type: formType
			};
			let hasError = false;
			if (formType === 'company') {
				for (let field in this._companyFields) {
					if (!this._companyFields.hasOwnProperty(field)) {
						continue;
					}
					let fieldValue = this._companyFields[field].value();
					if (!fieldValue && field !== 'vat') {
						this._companyFields[field].error(D.Lang.get('profile.team.purchase.errors.' + field + '.empty'));
						hasError = true;
					} else {
						this._companyFields[field].error(null);
						if (field === 'phone') {
							data[field] = '+' + fieldValue.code + fieldValue.value;
						} else {
							data[field] = fieldValue;
						}
					}
				}
			}
			if (hasError) {
				return;
			}
			let formData = {
				purchase: data,
				userCount: this._teamUsersCount ? this._teamUsersCount.value() : 1,
				teamCount: this._teamCount ? this._teamCount.value() : null,
				priceOptions: this._getPriceOptionsData()
			};
			this._isCheckingPurchase = true;
			new RPC('/api/web_rpc.php').send('checkGiftCardPurchase', formData, this._onCheckPurchase);
		},

		_onCheckPurchase: function(data) {
			this._isCheckingPurchase = false;
			if (!data || typeof data.error === 'string') {
				this._errorNodeCheck = T.error(D.Lang.get('profile.team.purchase.errors.' + data.error)).prepend(this._purchaseForm);
				return;
			}
			if (data.ok) {
				this._purchase();
				return;
			}
			if (data.errors.purchase) {
				for (let field in data.errors.purchase) {
					if (!data.errors.purchase.hasOwnProperty(field)) {
						continue;
					}
					let error = data.errors.purchase[field];
					if (this._tabHeaders[this.TYPE_COMPANY].value()) {
						this._companyFields[field].error(D.Lang.get('profile.team.purchase.errors.' + field + '.' + error));
					}
				}
				return;
			}
			this._errorNodeCheck = T.error(D.Lang.get('profile.team.purchase.errors.general')).prepend(this._purchaseForm);
		},

		_purchase: function() {
			if (this._isPurchasing) {
				return;
			}
			if (this._errorNode) {
				this._errorNode.remove();
			}
			let formType = this._tabHeaders[this.TYPE_COMPANY].value() ? 'company' : 'private';
			let data = {
				type: formType
			};
			if (formType === 'company') {
				for (let field in this._companyFields) {
					if (!this._companyFields.hasOwnProperty(field)) {
						continue;
					}
					let fieldValue = this._companyFields[field].value();
					if (field === 'phone') {
						data[field] = '+' + fieldValue.code + fieldValue.value;
					} else {
						data[field] = fieldValue;
					}
				}
			}
			let formData = {
				purchase: data,
				eventId: this.data.id,
				userCount: this._teamUsersCount ? this._teamUsersCount.value() : 1,
				teamCount: this._teamCount ? this._teamCount.value() : null,
				priceOptions: this._getPriceOptionsData()
			};
			this._isPurchasing = true;
			new RPC('/api/web_rpc.php').send('purchaseGiftCard', formData, this._onPurchase);
		},

		_onPurchase: function(data) {
			if (!data || typeof data.error === 'string') {
				this._errorNode = T.error(D.Lang.get('profile.team.purchase.errors.' + data.error)).prepend(this._purchaseForm);
				this._isPurchasing = false;
				return;
			}
			if (!data.errors) {
				if (data.url) {
					window.location.href = data.url;
				}
				this._paymentId = data.paymentId;
				D.loadingOverlay(this.node);
				if (data.paymentMethod === DR.services.PurchaseTicket.PAYMENTMETHOD_BRAINTREE) {
					D.onBraintree(this._onBraintree);
          this._gtagPricing.send('begin_checkout');
				} else if (data.paymentMethod === DR.services.PurchaseTicket.PAYMENTMETHOD_EVERYPAY) {
					this._continueWithEveryPay();
				}
				return;
			}
			this._isPurchasing = false;
			if (data.errors.purchase) {
				for (let field in data.errors.purchase) {
					if (!data.errors.purchase.hasOwnProperty(field)) {
						continue;
					}
					let error = data.errors.purchase[field];
					if (this._tabHeaders[this.TYPE_COMPANY].value()) {
						this._companyFields[field].error(D.Lang.get('profile.team.purchase.errors.' + field + '.' + error));
					}
				}
				return;
			}
			this._errorNode = T.error(D.Lang.get('profile.team.purchase.errors.general')).prepend(this._purchaseForm);
		},

		_onBraintree: function() {
			this._mGetBraintreeToken = new DR.services.GetBraintreeClientToken();
			this._mGetBraintreeToken.onLoad = this._onBraintreeToken;
			this._mGetBraintreeToken.onError = this._onBraintreeTokenError;
			this._mGetBraintreeToken.call({
				eventId: this.data.id
			});
		},

		_onBraintreeToken: function() {
			this._braintreeToken = this._mGetBraintreeToken.re.token;
			this._createBraintree();
		},

		_onBraintreeTokenError: function() {

		},

		_createBraintree: function() {
			D.removeLoadingOverlay(this.node);
			this._braintreePopup = new T.Popup({
				className: 'popup-payment',
				overlayClick: false,
				onClose: D.closure(this, function() {
					this._isPurchasing = false;
				})
			});
			this._braintreeContainer = mkE({
				tag: 'div',
				els: [
					{
						tag: 'div',
						id: 'braintree-container'
					},
					this._braintreeButton = mkE({
						tag: 'button',
						className: 'button button-pink button-block button-disabled',
						text: D.Lang.get('gift-card.purchase'),
						style: {
							marginTop: '12px'
						}
					})
				]
			});
			this._braintreePopup.setContent(this._braintreeContainer);
			let braintreeParams = {
				authorization: this._braintreeToken,
				container: '#braintree-container',
				card: {
					cardholderName: true
				},
				translations: D.LANG === 'lv' ? D.Lang.getBraintree() : null,
				vaultManager: true
			};
			if (D.BRAINTREE_3DS_ENABLED) {
				braintreeParams.threeDSecure = true;
			}
			braintree.dropin.create(braintreeParams, this._onBraintreeCreate);
			this._braintreePopup.open();
		},

		_onBraintreeCreate: function(createErr, instance) {
			this._braintreeInstance = instance;
			this._braintreeButton.addEventListener('click', this._onBraintreeMethodSelect);
			removeClassName(this._braintreeButton, 'button-disabled');
		},

		_onBraintreeMethodSelect: function() {
			if (this._errorNode) {
				this._errorNode.remove();
				delete this._errorNode;
			}
			let params = {};
			if (D.BRAINTREE_3DS_ENABLED) {
				params.threeDSecure = {
					amount: (this._price / 100).toFixed(2),
					email: this.user.email
				};
			}
			this._braintreeInstance.requestPaymentMethod(params, this._onBraintreeMethodData);
		},

		_onBraintreeMethodData: function(requestPaymentMethodErr, payload) {
			if (requestPaymentMethodErr) {
				console.log(requestPaymentMethodErr);
				/*this._errorNode = T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled'));
				D.insertBefore(this._errorNode, this._braintreeContainer);*/
			} else if (payload.nonce) {
				D.loadingOverlay(this.node);
				this._mProcessBraintree = new DR.services.ProcessBraintreeTransaction();
				this._mProcessBraintree.nonce = payload.nonce;
				this._mProcessBraintree.paymentId = this._paymentId;
				this._mProcessBraintree.onLoad = this._onBraintreeSuccess;
				this._mProcessBraintree.onError = this._onBraintreeError;
				this._mProcessBraintree.call({eventId: this.data.id});
				this._braintreePopup.close();
			}
		},

		_onBraintreeSuccess: function() {
			let re = this._mProcessBraintree.re;
			if (re.ok) {
				this._gtagPricing.custom.transaction_id = String(this._mProcessBraintree.paymentId);
				this._gtagPricing.send('purchase');
				Section.navigate(D.url('gift-card/?pmt-success'));
			} else {
				D.removeLoadingOverlay(this.node);
				let text = D.Lang.get('profile.team.purchase.errors.cancelled');
				if (re.errors.length) {
					text = re.errors[0];
				}
				this._errorNode = T.fatal(text).append(this._errorHolder);
			}
		},

		_onBraintreeError: function() {
			D.removeLoadingOverlay(this.node);
			this._errorNode = T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled')).append(this._errorHolder);
		},

		_continueWithEveryPay() {
			this._gtagPricing.send('begin_checkout');
			this._gtagPricing.custom.transaction_id = String(this._paymentId);
			this._gtagPricing.store();
			this._everyPay.getPaymentLink(
				this._paymentId,
				this._onEveryPayLink,
				this._onEveryPayLinkError
			);
		},

		_onEveryPayLink(link) {
			D.removeLoadingOverlay(this.node);
			if (link) {
				window.location.href = link;
			}
		},

		_onEveryPayLinkError() {
			T.fatal(D.Lang.get('profile.team.purchase.errors.cancelled')).append(this._errorHolder);
			D.removeLoadingOverlay(this.node);
		},

		_onEveryPayInit() {
			this._onEveryPayChange();
			this._moveEveryPayCheckbox();
			D.removeLoadingOverlay(this.node);
		},

		_onEveryPayChange() {
			this._isEveryPayOK = this._everyPay.hasSelectedPaymentMethod() && this._everyPay.hasAgreedToRules();
			if (this._isEveryPayOK) {
				removeClassName(this._buyButton, 'button-disabled');
			} else {
				addClassName(this._buyButton, 'button-disabled');
			}
		},

		_moveEveryPayCheckbox() {
			if (!this._everyPay) {
				return;
			}
			let checkbox = this._everyPay.getRulesCheckbox();
			if (!D.CSS.cssBrTablet) {
				checkbox.append(this._bottomContentNode);
			} else {
				this._everyPay.resetRulesCheckbox();
			}
		},

		onResize() {
			this._moveEveryPayCheckbox();
		}
	},
	Section
);

SectionGiftCard.Success = Class(
	/**
	 * @lends {SectionGiftCard.Success#}
	 */
	{
		__NAME: 'SectionGiftCard.Success',

		bodyClass: 'small-nav grey full-container',
		menuItem: 'gift-card',

		draw() {
			if (!D.ID) {
				Section.navigate(D.url('gift-card'));
				return;
			}
			new RPC('/api/web_rpc.php').send('getLastGiftCardInfo', {}, this._onGiftCard);
		},

		_onGiftCard(re) {
			if (re.error) {
				Section.navigate(D.url('gift-card'));
				return;
			}
			this.node = mkE({
				tag: 'div',
				id: 'SectionGiftCardSuccess',
				className: 'container'
			}).append(this.layout.ct());

			T.success(D.Lang.get('gift-card.purchased'), true, true).append(this.node);

			const multiple = re.cards.length > 1;

			mkE({
				tag: 'h1',
				className: 'h2',
				text: D.Lang.get(multiple ? 'gift-card.multiple.thanks' : 'gift-card.thanks')
			}).append(this.node);

			let text = mkE({
				tag: 'p',
				text: D.Lang.get(multiple ? 'gift-card.multiple.purchase-text' : 'gift-card.purchase-text').replace('%USER_EMAIL%', re.email)
			}).append(this.node);

			D.replaceWithNode(text, /%RG_EMAIL%/g, function() {
				return mkE({
					tag: 'a',
					href: 'mailto:' + D.Lang.get('gift-card.rg-email'),
					text: D.Lang.get('gift-card.rg-email'),
					target: '_blank'
				});
			});

			const table = {
				tag: 'table',
				className: 'table',
				els: []
			};

			for (let i = 0; i < re.cards.length; i++) {
				const card = re.cards[i];
				table.els.push({
					tag: 'tr',
					els: [
						{
							tag: 'td',
							text: card.event.id ? card.event.title : D.Lang.get('gift-card.event.unknown.title')
						},
						{
							tag: 'td',
							els: [
								{
									tag: 'a',
									href: card.url,
									target: '_blank',
									className: 'button button-pink',
									text: D.Lang.get('gift-card.download')
								}
							]
						}
					]
				});
			}

			mkE(table).append(this.node);

			this.ready();
		}
	},
	Section
);

SectionGiftCard.Processing = Class(
	/**
	 * @lends {SectionGiftCard.Processing#}
	 */
	{
		__NAME: 'SectionGiftCard.Processing',

		bodyClass: 'small-nav grey hide-tablet-footer',
		menuItem: 'gift-card',

		eventId: null,
		eventSlug: null,
		/** @type {DR.events.struct.Event} */
		event: null,
		paymentId: null,

		__construct(eventSlug) {
			this.eventSlug = eventSlug;
		},

		route(){
			this.paymentId = Number(this.url.get.v('id'));
			this._gtagPricing = D.gtag.Pricing.getStored(String(this.paymentId));
		},

		draw() {
			this._mGetEvent = new DR.events.Get();
			this._mGetEvent.onLoad = this._mGetEventRe;
			this._mGetEvent.onError = this._mGetEventErr;
			this._mGetEvent.select = [
				new DR.events.select.Event().id().title().maxPlayers().minPlayers().status().seoTitle().settings()
					.startTime().endTime(),
			];
			this.apiCall.addMethod(this._mGetEvent);

			this._paymentProcess = new T.ProcessPayment(this.paymentId, this._onSuccess, this._onFailure, this.apiCall);

			this.apiCall.onLoad = this._onApiCallRe;
			this.apiCall.call({
				eventSeoTitle: this.eventSlug
			});
		},

		_mGetEventRe: function(){
			this.event = this._mGetEvent.re;
			this.eventId = this._mGetEvent.re.id;
			this.eventSlug = this._mGetEvent.re.seoTitle;
		},

		_mGetEventErr: function(){
			this.event = null;
			this.eventId = 0;
			this.eventSlug = '';
		},

		_onApiCallRe() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionGiftCardBuy'
			}).append(this.layout.ct());

			this._drawHeader();

			this._drawContent();

			mkE({
				tag: 'div',
				className: 'container purchase-disclaimer centered',
				els: [
					{
						tag: 'div',
						className: 'disclaimer',
						els: [
							D.Lang.get('profile.team.purchase.receiver'),
							{
								tag: 'br'
							},
							D.Lang.get('profile.team.purchase.address')
						]
					}
				]
			}).append(this.node);

			this.ready();
		},

		_drawHeader() {
			let header = mkE({
				tag: 'div',
				className: 'header container'
			}).append(this.node);
			let title = mkE({
				tag: 'h4'
			}).append(header);
			if (!this.event || this.event.id === 0) {
				mkE.appendTypeElement(title, D.Lang.get('gift-card'));
			} else {
				mkE.appendTypeElement(title, [
					{
						tag: 'span',
						className: 'prefix',
						text: D.Lang.get('gift-card') + ' - '
					},
					this.event.title
				]);
			}
			let caption = D.Lang.get('gift-card.event.start-any-time');
			if (this.event && this.event.id && this.event.settings.type !== 'anytime') {
				caption = D.Date.formatDateRange(this.event.startTime, this.event.endTime, 'j. %F, H:i', 'H:i', ' - ');
			}
			mkE({
				tag: 'div',
				className: 'caption',
				text: caption
			}).append(header);
		},

		_drawContent() {
			let content = mkE({
				tag: 'div',
				className: 'content container',
				els: [
					this._paymentProcess
				]
			}).append(this.node);
		},

		onShow() {
			this._paymentProcess.onShow();
		},

		_onSuccess() {
			if (this._gtagPricing) {
				this._gtagPricing.send('purchase');
				D.gtag.Pricing.removeStored(String(this.paymentId));
			}
			setTimeout(() => {
				window.location.href = D.url('gift-card/?pmt-success');
			}, 2500);
		},

		_onFailure() {
			setTimeout(() => {
				window.location.href = D.url('gift-card/event/' + this.eventSlug + '?payment-failed');
			}, 2500);
		}
	},
	Section
);